import ef from 'ef/ef';
var utils = require('lib/utils');

var SurveyService = {
  initialize: function(mapping){
    mapping = (mapping || {});
    this.mapping = mapping;
    this.ContentProvider = require('services/content-provider');
  },

  surveyUrl: function(courseSlug, returnHash){
    var settings = this.mapping[courseSlug];
    if(!settings) {
      console.warn("Invalid survey mapping for slug: ", courseSlug);
      console.warn("Here are the survey mappings for reference: ", this.mapping);
      // trigger something special...
      return null;
    }
    //var redirectPath = window.location.pathname + "#" + EF.module.currentActivity.currentPage.path();
    var hash = returnHash || window.location.hash;
    if (!returnHash && ef.module && ef.module.currentActivity && ef.module.currentActivity.currentPage){
      hash = `#${ef.module.currentActivity.currentPage.path()}`;
    }
    var redirectPath = window.location.pathname + hash;
    var url = "/student/redirect_to_survey?survey_id=:survey_id&module_redirect_url=:redirect_url";
    url = url.replace(':survey_id', settings.survey_id);
    url = url.replace(':redirect_url', encodeURIComponent(redirectPath));
    return url;
  },

  userHasCompletedSurvey: function(courseSlug) {    
    return this.ContentProvider.SurveyService.userHasCompletedSurvey(courseSlug);
  },

  getActivityProgressForSlug: function(courseSlug){
    var settings = this.mapping[courseSlug];
    return ef.activityProgresses.find(function(ap){
      if (ef.options.local){
        return ap.get('slug') === courseSlug;
      } else {
        return ap.get('activity_id') === settings.id;
      }
    });
  }

};

module.exports = SurveyService;
